import { Routes } from '@/models/router/router.interface';
import { ModalUnsafeExitStates } from '@/models/modal/modal.enum';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

class NavigationPresenter {

	public interruptClosingOfPageIfUnsavedChanges(): void {
		window.addEventListener('beforeunload', (event) => {
			if (!campaignPresenter.hasCampaignDataChanged()) {
				return;
			}

			event.preventDefault();
			event.returnValue = '';
		});
	}

	public navigateToPage(path: Routes): void {
		if (campaignPresenter.hasCampaignDataChanged()) {
			store.mutations.setNextRoute(path);
			store.mutations.setModalUnsafeExitState(ModalUnsafeExitStates.EXITING);
			return;
		}

		store.mutations.setCurrentRoute(path);
	}
}

export default new NavigationPresenter();
